import Api from "./Api.js";

const resource = "/emails";

export default {
  send(sourceOrderNumber, template) {
    return Api.post(`${resource}/resend-email`, {
      'source_order_number': sourceOrderNumber,
      'type': template
    });
  },
};
